export default "__VITE_ASSET__1cc9f41d__"